const appRoot = "/";

export const spaceLoaderLinks = {
    appRoot: appRoot,
    space: (spaceId: string) => `/${spaceId}`,
};
